export const messages = {
  name: '訊息 |||| 訊息',
  fields: {
    id: 'ID',
    title: '標題',
    content: '內容',
    type: '類型',
    priority: '優先級',
    status: '狀態',
    targetType: '目標類型',
    targetData: '目標數據',
    membershipLevels: '會員等級',
    targetUsers: '目標用戶',
    actionType: '動作類型',
    actionData: '動作數據',
    imageUrl: '圖片連結',
    image: '橫幅圖片',
    imageHelp: '上傳橫幅圖片（2:1 長寬比）',
    sendPush: '發送推播通知',
    sendEmail: '發送電子郵件',
    deliveryTime: '發送時間',
    scheduledAt: '排程時間',
    sentAt: '發送時間',
    expiresAt: '過期時間',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    totalRecipients: '總接收者',
    totalReads: '總閱讀數',
    totalClicks: '總點擊數',
    readRate: '閱讀率',
    failedCount: '失敗數',
    recipients: '接收者',
    reads: '閱讀',
    pushEnabled: '推播',
    contentHelp: '將顯示給用戶的訊息內容',
    imageUrlHelp: '可選的圖片連結，與訊息一起顯示',
    actionDataHelp: '根據動作類型，可以是 URL、畫面名稱或深層連結數據',
    websiteUrl: '網站連結',
    deeplinkUrl: '深層連結',
    appScreen: '應用程式畫面',
    membershipHelp: '選擇要定位的會員等級（留空表示全部）',
    scheduledHelp: '設定訊息在特定時間發送',
    expiresHelp: '訊息將在此日期後隱藏',
    pushNotificationDetails: '推播通知詳情',
    pushTitle: '推播標題',
    pushBody: '推播內容',
    actionTarget: '動作目標',
    active: '啟用',
    validFrom: '生效起始時間',
    validUntil: '生效結束時間'
  },
  filters: {
    search: '搜尋',
    createdAfter: '建立時間晚於',
    createdBefore: '建立時間早於'
  },
  types: {
    announcement: '公告',
    promotion: '促銷',
    system: '系統',
    personal: '個人',
    alert: '警報'
  },
  priorities: {
    low: '低',
    normal: '一般',
    high: '高',
    urgent: '緊急'
  },
  statuses: {
    draft: '草稿',
    scheduled: '已排程',
    sent: '已發送',
    failed: '失敗',
    sendNow: '立即發送'
  },
  targetTypes: {
    all: '所有用戶',
    membership: '按會員等級',
    group: '按群組',
    individual: '個別用戶'
  },
  actionTypes: {
    none: '無',
    url: '開啟連結',
    screen: '導航至畫面',
    deeplink: '深層連結'
  },
  memberships: {
    standard: '標準',
    silver: '銀級',
    gold: '金級',
    platinum: '白金',
    vip: 'VIP'
  },
  sections: {
    content: '訊息內容',
    properties: '訊息屬性',
    targeting: '目標設定',
    action: '動作配置',
    delivery: '發送選項',
    statistics: '發送統計',
    timeline: '時間軸'
  },
  create: {
    title: '建立新訊息',
    subtitle: '建立新訊息以發送給您的用戶',
    backToList: '返回訊息列表',
    contentSection: '訊息內容',
    propertiesSection: '訊息屬性',
    targetingSection: '目標受眾',
    deliverySection: '發送與動作',
    schedulingSection: '排程設定',
  },
  notifications: {
    createSuccess: '訊息建立成功',
    updateSuccess: '訊息更新成功',
    deleteSuccess: '訊息刪除成功',
  },
  createHint: '建立新訊息以發送給您的用戶。訊息可以定位到特定群組並包含推播通知。',
  pushNotificationInfo: '啟用推播通知後，用戶將在其裝置上收到通知，點擊後可開啟訊息或導航到配置的動作。',
  pushNotEnabledMessage: '此訊息未啟用推播通知。',
  resendPushHelp: '使用下方的勾選框，在儲存時重新發送推播通知。',
  noExpiry: '無過期時間',
  imagePreview: '圖片預覽',
  clickToUpload: '點擊上傳或拖放檔案',
  imageRequirements: 'PNG、JPG 最大 5MB（將裁切為 2:1 長寬比）',
  selectImage: '選擇圖片',
  selectScreen: '選擇應用程式畫面',
  appScreen: '應用程式畫面',
  notificationDetailInfo: '這將開啟訊息詳細畫面並顯示訊息內容。',
  screenParams: '畫面參數 (JSON)',
  screenParamsHelp: '要傳遞給畫面的可選參數',
  actionHelp: {
    none: '開啟訊息時無動作',
    url: '在瀏覽器中開啟網站',
    screen: '導航到應用程式中的畫面',
    deeplink: '開啟深層連結'
  },
  urlHelp: '輸入完整的網址，包括 https://',
  deeplinkHelp: '輸入應用程式的深層連結',
  actionTargetValue: '動作目標值',
  errors: {
    invalidFileType: '無效的檔案類型。請上傳 PNG 或 JPG 圖片。',
    fileTooLarge: '檔案太大。最大大小為 5MB。',
    uploadFailed: '上傳圖片失敗。請再試一次。',
    imageUploaded: '圖片上傳成功'
  },
  editSentWarning: '此訊息已發送，無法編輯。您只能查看詳細資訊和統計數據。',
  editSentInfo: '此訊息已發送。您可以更新內容並可選擇重新發送推播通知給所有接收者。',
  statistics: '統計數據',
  actions: {
    send: '發送訊息',
    schedule: '排程',
    cancel: '取消',
    duplicate: '複製',
    preview: '預覽',
    viewRecipients: '查看接收者',
    resendNotification: '重新發送推播通知給所有接收者'
  },
  validation: {
    titleRequired: '標題為必填',
    contentRequired: '內容為必填',
    invalidUrl: '請輸入有效的連結',
    scheduledDateInPast: '排程日期不能是過去時間',
    expiryBeforeScheduled: '過期日期必須在排程日期之後'
  },
  success: {
    created: '訊息建立成功',
    updated: '訊息更新成功',
    sent: '訊息發送成功',
    scheduled: '訊息排程成功',
    deleted: '訊息刪除成功',
    imageUploaded: '圖片上傳成功'
  },
  error: {
    sendFailed: '訊息發送失敗',
    scheduleFailed: '訊息排程失敗',
    loadFailed: '訊息載入失敗'
  },
  multilang: {
    title: '多語言翻譯',
    helperText: '為您的訊息提供不同語言的翻譯。英文為必填，其他語言為選填。',
    copyFromBasic: '從主要文字複製',
    translateFromSimplified: '從簡體中文翻譯',
    translateFromTraditional: '從繁體中文翻譯',
    titleHelperText: '標題將顯示在通知和訊息列表中',
    contentHelperText: '使用者將閱讀的主要訊息內容',
    nonEnglishNote: '非英文翻譯為選填。如未提供，將使用英文版本。'
  },
  appScreens: {
    Home: { name: '主頁', description: '應用程式主畫面' },
    Chargers: { name: '充電樁列表', description: '瀏覽所有充電樁' },
    ChargerDetail: { name: '充電樁詳情', description: '查看特定充電樁' },
    Sites: { name: '站點列表', description: '瀏覽充電站點' },
    SiteDetail: { name: '站點詳情', description: '查看特定站點' },
    Profile: { name: '個人資料', description: '用戶帳戶設定' },
    PersonalInformation: { name: '個人資訊', description: '編輯個人詳細資料' },
    MyVehicles: { name: '我的車輛', description: '管理車輛' },
    PaymentMethods: { name: '付款方式', description: '管理付款卡' },
    ChargingHistory: { name: '充電記錄', description: '查看過往充電紀錄' },
    ChargingSession: { name: '充電中', description: '當前充電狀態' },
    Notifications: { name: '通知', description: '所有通知' },
    NotificationDetail: { name: '通知詳情', description: '查看特定訊息' },
    Support: { name: '客戶支援', description: '幫助與支援' },
    FAQ: { name: '常見問題', description: '常見問題解答' },
    About: { name: '關於', description: '關於本應用程式' },
  }
};